module.exports = __webpack_public_path__ + "img/solana.fe9485ea.png";